import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import UserFormSections from "./UserFormSections.js"

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pk: null,
            grupo_id: null,
            departamento_id: null,
            departamentopadre_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }


    ResetForm() {
        this.setState({
            pk: null,
            grupo_id: null,
            departamento_id: null,
            departamentopadre_id: null,
        });
    }


    setSelects(data) {
        this.setState({
            pk: data.pk,
            grupo_id: data.grupo_id,
            departamento_id: data.departamento_id,
            departamentopadre_id: data.departamentopadre_id,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.usuarios.delete}
                postUrl={api.usuarios.usuarios.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Usuario ha sido eliminado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Usuario"}
                buttonTitle={"Eliminar Usuario"}
                buttonIcon={"fa fa-trash fa-lg"}
                buttonClass={"btn-danger"}
                saveButtonLabel={"Eliminar"}
                danger={true}
                className={"ui-modal-dialog ui-modal-lg"}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.ResetForm()}
            >
                <div className="ui-form">
                    <div className="ui-alert ui-alert-danger">
                        <i className="ti ti-trash" aria-hidden="true"></i>
                        Se eliminará el usuario seleccionado.
                    </div>
                    <UserFormSections
                        disabled={true}
                        departamentoId={this.state.departamento_id}
                        departamentoPadreId={this.state.departamentopadre_id}
                        onGrupoChange={(data) => this.setState({ departamentopadre_id: (data != null ? data.pk : 0), departamento_id: null })}
                        onSubgrupoChange={(data) => this.setState({ departamento_id: (data != null ? data.pk : 0) })}
                    />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Usuarios/Delete.js